import React from 'react';

import type { ImageProps } from './Image.types';
import { BaseImage } from './subcomponents/BaseImage';
import { ResponsiveImage } from './subcomponents/ResponsiveImage';
import { getImageForCurrentScreen } from './Image.utils';

export const Image = (props: ImageProps) => {
  const { source, responsive, ...rest } = props;
  const sourceForCurrentScreen = getImageForCurrentScreen(source);

  return responsive ? (
    <ResponsiveImage source={sourceForCurrentScreen} {...rest} />
  ) : (
    <BaseImage source={sourceForCurrentScreen} {...rest} />
  );
};
